'use client';

import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import GTMHead from './GTMHead';

declare global {
  interface Window {
    CookieInformation: any;
    CookieConsent: any;
  }
}

export default function HeadScripts() {
  const locale = useLocale();

  useEffect(() => {
    checkScript();
  });

  return (
    <>
      <script
        id='gtmlayer'
        dangerouslySetInnerHTML={{
          __html: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag(\'consent\', \'default\', {
      \'ad_storage\': \'denied\',
      \'ad_user_data\': \'denied\',
      \'ad_personalization\': \'denied\',
      \'analytics_storage\': \'denied\',
      \'wait_for_update\': 500
      });
      gtag(\'set\', \'ads_data_redaction\', true);`,
        }}
      ></script>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GTM_ID}`}
      />
      <script
        id='CookieConsent'
        type='text/javascript'
        data-culture={locale}
        src={`https://policy.app.cookieinformation.com/uc.js`}
        data-gcm-version='2.0'
      ></script>
      <GTMHead />
    </>
  );
}

const showConsent = () => {
  const cookieWrapper = document.querySelectorAll<HTMLElement>(
    '#cookie-information-template-wrapper'
  );
  const cookieBtn = document.querySelectorAll<HTMLElement>('#Coi-Renew');
  if (!cookieWrapper.length && !cookieBtn.length) {
    setTimeout(showConsent, 100);
    return;
  }
  cookieWrapper[0].style.display = 'block';
  cookieBtn[0].style.display = 'block';
};

const checkScript = () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  if (window.CookieInformation?.loadConsent && window.CookieConsent?.show) {
    window.CookieInformation.loadConsent();
    showConsent();
  } else {
    setTimeout(checkScript, 200);
  }
};
